<template>
	<div class="i-multi-view" v-if="config">
		<span v-if="config.type === 'index'">{{index+1}}</span>
        <a   v-if="config.type === 'link'" :href="config.link(value)" target="_blank">{{config.label}}</a>
        
        
        <div v-else-if="config.type === 'action'">
            <btn :l="config.label" @press="(e)=>config.action(e,data[index])" />
        </div>

        <div v-else-if="config.type === 'number' || config.type === Number"  >{{value | numbering}}</div>
        <div v-else-if="config.type === 'string' || config.type === String || config.type === 'text'" >{{value}}</div>
        <div v-else-if="config.type === 'lang' || config.type === 'lang-text'" >{{value&&value[lang]}}</div>
        <div v-else-if="config.type === 'options' || config.type === 'smart-select'" v-bind:x="x=config.options.find(o=>o.value == value)">{{ x&&x.label }}</div>
        <div v-else-if="config.type === 'boolean' || config.type === Boolean" :class="'cell-boolean-'+value">{{value?'Да':'Нет'}}</div>
        <div v-else-if="config.type === 'date' || config.type === Date">{{value | date}}</div>
        <div v-else-if="config.type === 'wysiwyg'" v-html="value"/>
        <img v-else-if="config.type === 'image'" :src="value+'?w=350'" width="120"/>
        <i-currency v-else-if="config.type === 'currency'" :value="value" />
        <div v-else>{{value}}</div>
<!-- 
        <i-array-sort v-if="config.type === 'array-sort'" :value="value" :placeholder="config.placeholder" :required="config.required" @input="change" :label="config.label" :elements="config.elements" />
        <i-array-editor v-if="config.type === 'array'  || config.type === Array" :value="value" :required="config.required" @input="change" :label="config.label" :scheme="config.scheme" :mode="config.mode" />
        <i-tick-box v-if="config.type === 'tick-box'" :value="value" :placeholder="config.placeholder" :required="config.required" @input="change" :label="config.label" :elements="config.elements" />
        <i-table-edit v-if="config.type === 'table'" :value="value" :required="config.required" @input="change" :label="config.label" />
        <i-lang-input v-if="config.type === 'lang'" :value="value" :placeholder="config.placeholder" :required="config.required" @input="change" :label="config.label" />
        <i-lang-input v-if="config.type === 'lang-text'" type="text" :value="value" :placeholder="config.placeholder" :required="config.required" @input="change" :label="config.label" :rows="config.rows" :cols="config.cols" />
        <i-lang-input v-if="config.type === 'lang-wysiwyg'" type="wysiwyg" :value="value" :placeholder="config.placeholder" :required="config.required" @input="change" :label="config.label" /> -->
	</div>
</template>

<script>
import iCurrency from "./i-currency.vue"
export default {
props:["config", "value", "index"],
components:{iCurrency},
  name: 'i-multi-view',

  data () {
    return {

    }
  }
}
</script>

<style lang="css" scoped>
</style>